import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { CropMapDefinitionRoutes } from '@/app/pages/cropmap-adapted/cropmap-definition/cropmap-definition-routes';

export const CropMapAdaptedRoutes: Route = {
    path: 'cropmap-adapted',
    data: { title: 'cropmap' },
    children: [
        {
            path: '',
            pathMatch: 'full',
            redirectTo: 'filter-report',
        },
        {
            path: 'enterprise-access',
            loadComponent: () =>
                import('./cropmap-enterprise-crop-access/cropmap-enterprise-crop-access.component').then(
                    (m) => m.CropmapAdaptedEnterpriseCropAccessComponent
                ),
            data: { title: 'enterprise_access' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'roles',
            loadComponent: () => import('./cropmap-roles/cropmap-roles.component').then((m) => m.CropmapAdaptedRolesComponent),
            data: { title: 'roles' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'users',
            loadComponent: () => import('./cropmap-users/cropmap-users.component').then((m) => m.CropmapAdaptedUsersComponent),
            data: { title: 'users' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'upload-report',
            loadComponent: () =>
                import('./cropmap-plantation-report-upload/cropmap-plantation-report-upload.component').then(
                    (m) => m.CropmapAdaptedPlantationReportUploadComponent
                ),
            data: { title: 'upload_report' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'geo-unit-representative-import',
            loadComponent: () =>
                import('./cropmap-geo-unit-representative-import-adapted/cropmap-geo-unit-representative-import-adapted.component').then(
                    (m) => m.CropmapGeoUnitRepresentativeImportAdaptedComponent
                ),
            data: { title: 'geo_unit_representative_import_adapted' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'filter-report',
            loadComponent: () =>
                import('./cropmap-plantation-report-filter/cropmap-plantation-report-filter.component').then(
                    (m) => m.CropmapAdaptedPlantationReportFilterComponent
                ),
            data: { title: 'filter_report' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'filter-report-multiyear',
            loadComponent: () =>
                import('./cropmap-plantation-report-filter-multiyear/cropmap-plantation-report-filter-multiyear.component').then(
                    (m) => m.CropmapPlantationReportFilterMultiyearComponent
                ),
            data: { title: 'filter_report_multiyear' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'plantation-estimation',
            loadComponent: () =>
                import('./cropmap-plantation-estimation/cropmap-plantation-estimation.component').then(
                    (m) => m.CropmapAdaptedPlantationEstimationComponent
                ),
            data: { title: 'plantation_estimation' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'mapbox-layer',
            loadComponent: () =>
                import('./cropmap-mapbox-layers/cropmap-mapbox-layers.component').then(
                    (m) => m.CropmapAdaptedMapboxLayersComponent
                ),
            data: { title: 'mapbox_layer' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'crm',
            loadComponent: () => import('./cropmap-crm/cropmap-crm.component').then((m) => m.CropmapAdaptedCrmComponent),
            data: { title: 'crm' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'usage-log',
            loadComponent: () =>
                import('./cropmap-usage-log/cropmap-usage-log.component').then((m) => m.CropmapAdaptedUsageLogComponent),
            data: { title: 'cropmap_usage_log' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        CropMapDefinitionRoutes,
    ],
};
